import IMainAppState from "../reducers/IMainAppState";
import {useSelector} from 'react-redux';
import {useEffect, useRef} from "react";

export default () => {
    const googleTagIdsRef = useRef(['GTM-NFHZMF2']); // Default GTM value.
    const googleTagId = useSelector((state: IMainAppState) => state.app.googleTagId);

    useEffect(() => {
        if(!googleTagId) {
            return;
        }

        const googleTagIds = googleTagIdsRef.current as string[];
        if(googleTagIds.indexOf(googleTagId) === -1) {
            googleTagIds.push(googleTagId);

            // Call window.gtm function
            // @ts-ignore
            window.gtm(window, document, 'script', 'dataLayer', googleTagId);
        }

    }, [googleTagId]);

    return null;
};